import http from '@/utils/http'

export const shareWX = (params) =>
  http(
    // 'https://www.ghbank.com.cn/recruit/front/hxRecruitRelease/shareRecruitReleaseWithWeChat',
    '/recruit/front/hxRecruitRelease/shareRecruitReleaseWithWeChat',
    {},
    'GET',
    params
  )

export const getFinancialProductListNew = (params) =>
  http('/product/findProductListNew', {}, 'GET', params)

export const getFinancialProductList = (params) =>
  http('/product/findProductList', {}, 'GET', params)

export const getFinancialProductDetails = (params) =>
  http('/product/findProductByCode', {}, 'GET', params)

export const getFundCompanyList = (params) =>
  http('/product/fund/getCompanyList', {}, 'GET', params)

export const getFundList = (params) =>
  http('/product/fund/findFundWebList', {}, 'GET', params)

export const getInsuranceList = (params) =>
  http('/product/findInsuranceList', {}, 'GET', params)

export const getGoldList = (params) =>
  http('/product/getMetalListV2', {}, 'GET', params)

export const getTreasureList = (params) =>
  http('/product/findCombinationTreasure', {}, 'GET', params)

export const getTrustList = (params) =>
  http('/product/findPrivateFundListB', {}, 'GET', params)

export const getHeaderHtml = () =>
  http(`${process.env.VUE_APP_WEBURL}sy/header.shtml`, null, 'GET')

export const getFooterHtml = () =>
  http(`${process.env.VUE_APP_WEBURL}sy/footer.shtml`, null, 'GET')

// 获取代销资管信托token
export const generateToken = () => http('/product/generateToken', {}, 'GET', {})
